<header>
    <h1>{{ "offered.header" | translate }}</h1>
</header>

<div class="content">
    <p>{{ "offered.content" | translate }}</p> 

</div>